<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    />
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList } from '@/api/env-monitor/log'

export default {
  name: 'env-monitor-log',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          { label: '拉取时间', prop: 'pullTime', search: true, type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss', minWidth: 170 },
          { label: '是否成功', prop: 'success', search: true, width: 100, type: 'select', dicData: [{ label: '失败', value: 0 }, { label: '成功', value: 1 }] },
          { label: '返回数量', prop: 'totalCount', width: 100 },
          { label: '保存变化', prop: 'savedCount', width: 100 },
          { label: '新增报警', prop: 'alarmCount', width: 100 },
          { label: '恢复报警', prop: 'recoverCount', width: 100 },
          { label: '耗时(ms)', prop: 'durationMs', width: 110 },
          { label: '信息摘要', prop: 'errorMessage', minWidth: 260, overHidden: true }
        ]
      }
    }
  }
}
</script>
